import { createContext, useContext, useState, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
// Contexts
import { useDatabase } from './DatabaseContext'
import { useAuthInfo } from '@propelauth/react'
import { Category } from '@mui/icons-material'

const ComponentLibraryDemoContext = createContext([])

const generateComponentLibraryExamples = (orgId) => {
    return [
        {
            id: uuidv4(),
            category: 'Study Information',
            component_name: 'Component 1',
            component_text: 'Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers.'
        },
        {
            id: uuidv4(),
            category: 'Study Information',
            component_name: 'Component 2',
            component_text: 'Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers.'
        },
        {
            id: uuidv4(),
            category: 'Study Information',
            component_name: 'Component 3',
            component_text: 'Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers. Appendix 16.1.6 lists the investigational product(s) batch numbers.'
        }
    ]
}

export function ComponentLibraryDemoProvider({ children }) {
    const [components, setComponents] = useState([])
    const authInfo = useAuthInfo()
    const orgId = authInfo.orgId

    useEffect(() => {
        const components = generateComponentLibraryExamples(orgId)
        setComponents(components)
    }, [])

    return (
        <ComponentLibraryDemoContext.Provider value={{ components, setComponents }}>
            {children}
        </ComponentLibraryDemoContext.Provider>
    )
}

export function useComponentLibraryDemo() {
    return useContext(ComponentLibraryDemoContext)
}
